const handleResponseConversionToJSON = async (response: Response) => {
    if (response.ok && !(response.status >= 400)) {
        return response.json();
    } else if (response.status >= 400) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
    } else {
        throw new Error('Something went wrong!');
    }
};

const handleResponseConversionToBlob = async (response: Response) => {
    if (response.ok && !(response.status >= 400)) {
        return response.blob();
    } else if (response.status >= 400) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
    } else {
        throw new Error('Something went wrong!');
    }
};

export { handleResponseConversionToJSON, handleResponseConversionToBlob };
